export const EXCHANGE_CONSENT_SESSIONS_NOT_ENDED = -20023;
